module.exports = __webpack_public_path__ + "app/announcement/modals/modal-delete-translate-1wqldLuZ.html";